import { FC } from 'react'
import { Typography, DialogActions, Button, Box } from '@mui/material'
import { StatefulDialog } from 'src/components/ui'
import { DialogNames } from 'src/enums'

interface DeleteVerizonReportModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const DeleteVerizonReportModal: FC<DeleteVerizonReportModalProps> = ({
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  return (
    <StatefulDialog
      name={DialogNames.DeleteVerizonReport}
      actions={
        <Box mb={2} mx={2}>
          <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={onConfirm} disabled={isLoading}>
              Delete
            </Button>
          </DialogActions>
        </Box>
      }
    >
      <Box minWidth="300px">
        <Typography variant="h6">Are you sure you want to delete the report?</Typography>
      </Box>
    </StatefulDialog>
  )
}
